<script>
import SearchAndActions from "@/components/Table/SearchAndActions.vue";
import Header from "@/components/Table/Header.vue";
import axios from "axios";
import moment from "moment";
import DataTable from "@/components/Table/DataTable.vue";
import ActionsButton from "@/components/Table/ActionsButton.vue";
import TablePagination from "@/components/Table/TablePagination.vue";

export default {
  name: "MeterConsumption",
  components: {TablePagination, ActionsButton, DataTable, Header, SearchAndActions},
  data() {
    return {
      breadcrumbs: [{text: "Home", path: "/dashboard", isActive: false}, {
        text: "Meter Consumptions",
        path: "/meter-consumptions",
        isActive: true
      }],
      tableData: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 0,
      },
      search: null,
      sort: '-created_at',
      month: moment().format('YYYY-MM'),
    }
  },
  created() {
    this.$store.dispatch("Config/setBreadCrumb", this.breadcrumbs);
  },
  mounted() {
    let page = this.$route.query.page ? this.$route.query.page : 1;
    let per_page = this.$route.query.per_page ? this.$route.query.per_page : 10;
    let search = this.$route.query.search ? this.$route.query.search : null;
    let sort = this.$route.query.sort ? this.$route.query.sort : '-created_at';
    let month = this.$route.query.month ? this.$route.query.month : moment().format('YYYY-MM');

    this.month = month;
    this.getListData(page, per_page, search, sort, month);
  },
  methods: {
    getListData(page = 1, per_page = 10, search = null, sort = '-created_at', month = null) {
      let url = '/admin/meter-consumers-list';
      let params = {
        page: page,
        per_page: per_page ? per_page : this.pagination.per_page,
        search: search ? search : this.search,
        sort: sort,
        month: month || this.month,
      };

      axios.get(url, {params})
          .then(response => {
            this.tableData = response.data.data;
            this.pagination = response.data.meta;
            this.sort = sort;
            this.month = params.month;

            this.$router.replace({query: params});
          })
    },
    onPageChange(page) {
      this.getListData(page, this.pagination.per_page, this.search, this.sort, this.month);
    },
    onPageSizeChanged(pageSize) {
      this.getListData(1, pageSize, this.search, this.sort, this.month);
    },
    onSearch(search) {
      this.search = search ? search : null;
      this.getListData(1, this.pagination.per_page, this.search, this.sort, this.month);
    },
    sortBy(field) {
      let sort = this.sort === field ? '-' + field : field;
      this.getListData(1, this.pagination.per_page, this.search, sort, this.month);
    },
    onMonth(month) {
      this.month = month ? month : null;
      this.getListData(1, this.pagination.per_page, this.search, this.sort, this.month);
    }
  }
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h6 class="text-uppercase font-weight-bold text-dark">Meter Consumptions</h6>
      </div>

      <div class="col-md-12">
        <div class="card p-4">
          <SearchAndActions
              :show-date="false"
              :show-month="true"
              :show-import="false"
              :initial-month="month"
              @search="onSearch"
              @month="onMonth"
              action-url="/admin/meter-consumers-list"
              download-file-name="meter-consumers"
          >
          </SearchAndActions>

          <div class="row">
            <div class="col-md-12">
              <DataTable>
                <template #header>
                  <Header :sort="false" title="Sl"/>
                  <Header :sort="false" title="Account No"/>
                  <Header :sort="false" title="Meter No"/>
                  <Header :sort="false" title="MI Code"/>
                  <Header :sort="false" title="Present Meter Reading"/>
                  <Header :sort="false" title="Present Reading Date"/>
                  <Header
                      :sort="false"
                      title="Actions"
                      v-if="
                          checkUsrPermissions([
                            'Meter_all',
                            'Meter_consumption'
                          ])
                        "
                  />
                </template>

                <tr
                    v-for="(data, index) in tableData"
                    :key="data.id"
                >
                  <th scope="row">
                    {{ pagination.from + index }}
                  </th>
                  <td>
                    <router-link :to="`/consumers/${data.customer_account.id}`">
                      {{ data.customer_account.account_number }}
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="'/meters/' + data.id">{{ data.meter_number }}</router-link>
                  </td>
                  <td>
                    {{ data.customer_account.meter_inspector.mi_code }}
                  </td>
                  <td>
                    {{ data.meter_current_consumption.water_unit  }}
                  </td>
                  <td>
                    {{ data.meter_current_consumption.reading_date_time | dateTimeFormat }}
                  </td>
                  <td
                      v-if="
                          checkUsrPermissions([
                            'Meter_all',
                            'Meter_consumption'
                          ])
                        "
                  >
                    <ActionsButton>
                      <router-link
                          :to="'/meters/' + data.id + '/consumptions'"
                      >
                        Details Consumption
                      </router-link>
                    </ActionsButton>
                  </td>
                </tr>
              </DataTable>

              <div class="mt-5" v-if="tableData.length">
                <TablePagination
                    :pagination="pagination"
                    @pagechanged="onPageChange"
                    @pagesizechanged="onPageSizeChanged"
                />
              </div>

              <div v-else>
                <p class="text-center font-weight-bold">
                  No data found
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
